<!-- Footer -->
<footer class="footer">
  <div>© 2026 AstraZeneca</div>
  <div>Version 1.0.0 • Status: Operational</div>
</footer>
